var blacklistServiceObj =
{
    getBlacklistItem(id) {
        console.log('getBlacklistItem: id=' + id);
        return axios.get('api/blacklist/' + id);
    },

    getBlacklist() {
        console.log('getBlackList');
        return axios.get('api/blacklist');
    },

    saveBlacklistItem(item) {
        console.log('saveOrderType:' + item.Id)
        return axios.post('api/blacklist', item);
    },
    deleteBlacklistItem(id, rowVersion) {
        console.log('deleteBlackListItem:' + id)
        return axios.delete('api/blacklist', { params: { id: id, rowVersion: rowVersion } });
    },
}

export const blacklistService = blacklistServiceObj;
